import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material/dialog';
import { perfil } from 'src/app/models/perfil';
import { AlertifyService } from 'src/app/services/alertify.service';
import { ProfileService } from 'src/app/services/profile.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-agregar-administrador-empresa',
  templateUrl: './agregar-administrador-empresa.component.html',
  styleUrls: ['./agregar-administrador-empresa.component.scss']
})
export class AgregarAdministradorEmpresaComponent implements OnInit {
  public documentos: any;
  public perfiles: perfil[];
  registerForm: UntypedFormGroup;
  public isForEdit = false;
  public dataInput: any;
  public tituloTxt = 'Crear administrador';

  constructor(
    public perfilSvc: ProfileService,
    public usrSvc: UserService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AgregarAdministradorEmpresaComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);
    if (data != null) {
      this.isForEdit = true;
      this.tituloTxt = 'Editar administrador';
    }
  }

  ngOnInit(): void {
    this.inicarFormulario();
  }

  inicarFormulario() {

/* public string nombre { get; set; }
public string documento { get; set; }
public int tipoDocumento { get; set; }
public string email { get; set; }
public string celular { get; set; }
public Guid empresaId { get; set; } */


    this.registerForm = new UntypedFormGroup({
      empresaId: new UntypedFormControl('', Validators.required),
      nombre: new UntypedFormControl('', Validators.required),
      tipoDocumento: new UntypedFormControl('', Validators.required),
      documento: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(15),
      ]),
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      celular: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern('[0-9]*'),
      ]),

    });
    this.registerForm.get('empresaId')?.setValue(this.dataInput);

    this.documentos = [
      { value: 1, nombre: 'CC' },
      { value: 2, nombre: 'Pasaporte' },
      { value: 3, nombre: 'NIT' },
      { value: 4, nombre: 'C. Extranjeria' },
    ];

  }

  getErrorMessageEmail() {
    if (this.registerForm.get('email')?.hasError('required')) {
      return 'El email es requerido';
    }
    if (this.registerForm.get('email')?.hasError('email')) {
      return 'No es un email valido';
    }
    return '';
  }

  guardar() {
    console.log('guardar adminsitrador');
    console.log(this.registerForm.value);

      //aqui mando a editar
      this.usrSvc.createAdministradorEmpresa(this.registerForm.value).subscribe((res) => {
        console.log('resultado EditarUsuario: ', res);
        if (res) {
          this.alertify.success('Usuario invitado');
          this.dialogRef.close();
        } else {
          this.alertify.error('El usuario no se ha podido invitar');
        }
      });
    
  }


}
/* public string nombre { get; set; }
public string documento { get; set; }
public int tipoDocumento { get; set; }
public string email { get; set; }
public string celular { get; set; }
public Guid empresaId { get; set; } */